/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Checkbox, Grid, Paper, Stack, styled, Typography } from '@mui/material';
import { isEmpty, keys } from 'lodash-es';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FieldValues, FormProvider, useForm, UseFormProps } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  ISubmissionSettingsResponse,
  ICandidate,
  uploadFileToS3,
  IJob,
  newMappingEntity,
  acceptWorkAssignment,
  getWorkAssignmentByCurrentRecruiterAndJob,
  getSubmissionsByCandidateIdAndJobId,
  getTopCV,
  getCandidateSubmissionSettingsTemplate,
  ISubmissionStageStatusSetting,
  IUserDTO,
} from 'wisestep-api';
import {
  PersonalInfo,
  LocationInfo,
  WorkExpForm,
  JobPreference,
  SalaryDetails,
  AssessmentInfo,
  DocumentInfo,
  WsButton,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
  IWorkAssignment,
  ChatBoxHeader,
  WsColors,
  WsDrawer,
  WsListingLoader,
} from 'wisestep-base';

import {
  useBusinessUnitContext,
  useUserContext,
  useWorkspaceContext,
} from '../../../../../context';
import CandidateProfileDetailsEdit from '../../../../../features/candidateLayout/components/childComponets/CandidateProfileDetails/CandidateProfileDetailsEdit';
import { updateWorkAuthorizationCategory } from '../../../../../features/candidateLayout/components/childComponets/CandidateProfileDetails/UpdateCandiadteDetailsHelper';
import BusinessUnit from '../../../../../features/conversationWidget/components/BusinessUnit';
import CVViewModal from '../../../../../features/conversationWidget/components/CVViewModal';
import { IOpenCvView } from '../../../../../features/conversationWidget/components/SubmissionForm';
import SubmissionFormNewFields from '../../../../../features/conversationWidget/components/SubmissionFormNewFields';
import WidgetJobManagement from '../../../../../features/conversationWidget/components/WidgetJobManagement';
import LinearProgressWithLabel from '../../../../../utils/LinearProgressWithLabel';
import { failed, success, warning } from '../../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../../utils/NotificationStore';
import { useConversationWidgetStore } from '../../../../../utils/useConversationWidgetStore';
import AddContactLink from '../../../../candidateLayout/components/childComponets/CandidateProfileDetails/components/AddContactLink';
import CardWithAccordion from '../../../../candidateLayout/components/childComponets/CardWithAccordion';
import EmailPopUp from '../../../../candidateLayout/components/EmailPopUp';
import { getProfessionalDetails } from '../../../../candidateLayout/utils/CandidateHelper';
import ActionFooter from '../../../../conversationWidget/components/ActionFooter';
import JobAssignmentSelection from '../../../../conversationWidget/components/JobAssignmentSelection';
import OtherSubmissionDetails from '../../../../conversationWidget/components/OtherSubmissionDetails';
import SubmitOptions from '../../../../conversationWidget/components/SubmitOptions';
import {
  getMandatoryFields,
  submissionSchema,
} from '../../../../conversationWidget/schema/formSchema';
import IOtherDocument from '../../../../conversationWidget/types/IOtherDocument';
import IResume from '../../../../conversationWidget/types/IResume';
import { SubmissionType } from '../../../../conversationWidget/types/SubmissionTypes';
import { trackCV, downloadCV } from '../../../../conversationWidget/utils/cvHelper';
import {
  getBuId,
  submissionFormDefaultValues,
} from '../../../../conversationWidget/utils/fieldDefaultValues';
import {
  addCandidateNote,
  createSubmissionEntity,
  onError,
  saveSubmission,
  updateSubmission,
} from '../../../../conversationWidget/utils/saveSubmission';
import useCheckExistingCandidate from '../../../../conversationWidget/utils/useCheckExistingCandidate';
import { useSubmissionStageStatus } from '../../../../crmSettings/hooks/useSubmissionStageStatus';
import useCandidateCV from '../../hooks/useCandidateCV';

interface IMapAsSubmission {
  selectedJob: IJob;
  onClose(): void;
  selectedCandidate?: ICandidate;
  hideJobSelection?: boolean;
  bulkSubmission?: boolean;
  onSuccess?: (msg: string) => void;
  setRemove?(): void;
}
const StyledCheckBox = styled(Checkbox)(() => ({
  padding: 0,
  marginRight: '10px',
}));

const MapAsSubmission = ({
  selectedJob,
  onClose,
  selectedCandidate,
  hideJobSelection = true,
  bulkSubmission = false,
  onSuccess,
  setRemove,
}: IMapAsSubmission) => {
  const [submissionSetting, setSubmissionSetting] = useState<ISubmissionSettingsResponse | null>(
    null
  );
  const { id: workspaceId } = useWorkspaceContext();
  const [openJobAssignmentSelection, setOpenJobAssignmentSelection] = useState<boolean>(false);
  const [assignmentData, setAssignmentData] = useState<IWorkAssignment | null>(null);
  const [assignmentToTeams, setAssignmentToTeams] = useState<string[]>([]);
  const [assignmentByRecruiters, setAssignmentByRecruiters] = useState<string[]>([]);
  const [isDuplicate, setIsDuplicate] = useState<boolean>(false);
  const [allowReset, setAllowReset] = useState<boolean>(false);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const [otherDocument, setOtherDocument] = useState<IOtherDocument[]>([]);
  // const onCandidateUpdate = useConversationWidgetStore((state) => state.onCandidateUpdate);
  const setNotification = useNotificationStore((state) => state.setNotification);
  const resume = useRef<IResume | null>(null);
  const [candidate, setCandidate] = useState<ICandidate | null>(
    selectedCandidate ? selectedCandidate : null
  );
  const buContext = useBusinessUnitContext();
  const { submissionStageData } = useSubmissionStageStatus();
  const cvViewSourcePage = useConversationWidgetStore((state) => state.cvViewSourcePage);
  const [isFormPrepopulated, setisFormPrepopulated] = useState<boolean>(false);
  // const updateFromPage = useConversationWidgetStore((state) => state.updateFromPage);
  // const updateView = useConversationWidgetStore((state) => state.updateView);
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;
  const formOptions: UseFormProps<any> = {
    resolver: yupResolver(submissionSchema(submissionSetting, buContext.length > 1 ? true : false)),
    defaultValues: submissionFormDefaultValues(null, selectedJob, buContext),
    mode: 'onChange',
  };

  const methods = useForm(formOptions);
  const {
    watch,
    reset,
    setValue,
    getValues,
    trigger,
    formState: { errors },
  } = methods;
  const [isResumeDeleted, setIsResumeDeleted] = useState<boolean>(false);
  const [linearProgressValue, setLinearProgressValue] = useState<number>(0);
  const [CVOptions] = useCandidateCV(candidate ?? ({} as ICandidate));
  const [openEditCandidate, setOpenEditCandidate] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [openEmail, setOpenEmail] = useState<boolean>(false);
  const [submissionEmailBody, setSubmissionEmailBody] = useState<string>('');
  const { mandatoryFields, shownFields } = getMandatoryFields(
    submissionSetting,
    buContext.length > 1
  );
  const [openCvView, setOpenCvView] = useState<IOpenCvView>({
    open: false,
    url: candidate?.resumeLocation ?? '',
  });
  const watchedValues = watch(mandatoryFields);
  const otherDetails = getProfessionalDetails(candidate ?? ({} as ICandidate)).filter(
    (field) => field.value !== 'NA' && !shownFields.includes(field.title)
  );

  const loggedInUser = useUserContext().userDTO as IUserDTO;

  const loggedInUserName =
    loggedInUser?.firstName?.trim() || loggedInUser?.lastName?.trim() || loggedInUser?.email || '';
  useEffect(() => {
    const fetchSubmissionSettings = async () => {
      try {
        const res = await getCandidateSubmissionSettingsTemplate(
          selectedJob.submissionFormTemplete ?? '',
          workspaceId ?? ''
        );
        setSubmissionSetting(res?.data?.fields ?? null);
      } catch (error) {
        console.error('Error fetching submission settings:', error);
        setNotification(warning('Submission settings api failed'));
        setSubmissionSetting(null);
      }
    };

    fetchSubmissionSettings();
  }, [selectedJob?.submissionFormTemplete, workspaceId]);
  useEffect(() => {
    let validFields = mandatoryFields.reduce((count, field) => {
      if (getValues(field) && !errors[field]) {
        count++;
      }
      return count;
    }, 0);
    if (
      mandatoryFields.includes('otherDocuments') &&
      candidate?.otherDocuments &&
      candidate.otherDocuments.length > 0
    ) {
      validFields++;
    }
    if (CVOptions?.length > 0 && mandatoryFields.includes('cvUpload')) {
      validFields++;
    }
    const count = (validFields / mandatoryFields.length) * 100;
    setLinearProgressValue(count);
  }, [watchedValues, errors, mandatoryFields, getValues, candidate?.otherDocuments, CVOptions]);

  const socialLinks = watch('socialLinks');
  const { openMergeCandidate, setOpenMergeCandidate, existingCandidate, newSocialLink } =
    useCheckExistingCandidate(socialLinks, candidate);

  useEffect(() => {
    if (!isFormPrepopulated && selectedCandidate) {
      reset(submissionFormDefaultValues(selectedCandidate, selectedJob, buContext));
      setisFormPrepopulated(true);
    }
  }, [selectedCandidate, reset]);

  useEffect(() => {
    if (candidate && allowReset)
      reset(submissionFormDefaultValues(candidate, selectedJob, buContext));
    bulkSubmission && trigger();
  }, [allowReset, bulkSubmission, candidate, reset, trigger]);

  const acceptJobAssignment = useCallback(
    async (assignment: IWorkAssignment, teamIdOrRecruiterId: string | undefined) => {
      try {
        if (teamIdOrRecruiterId) {
          await acceptWorkAssignment(assignment.id, teamIdOrRecruiterId);
          assignment.isAccepted = true;
          setAssignmentData(assignment);
          setNotification(success('Assignment accepted successfully. You can start working now.'));
          return true;
        }
        return false;
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    [setNotification]
  );

  useEffect(() => {
    const getAssignments = async () => {
      if (selectedJob.id) {
        const api = await getWorkAssignmentByCurrentRecruiterAndJob(selectedJob.id);
        const assignment: IWorkAssignment = api.data;
        setAssignmentData(assignment);
      }
    };
    getAssignments();
  }, [selectedJob.id]);

  const validAssignment = useCallback(
    async (job: IJob) => {
      if (job.id) {
        const api = await getWorkAssignmentByCurrentRecruiterAndJob(job.id);
        const assignment: IWorkAssignment = api.data;
        if (!isEmpty(api.data)) {
          setAssignmentData(assignment);
          if (!assignment.isClosed) {
            if (!assignment.isAccepted) {
              const assignmentToTeams = keys(assignment.assignedToTeams);
              setAssignmentToTeams(assignmentToTeams);
              const assignmentByRecruiters = keys(assignment.assignedByRecruiters);
              setAssignmentByRecruiters(assignmentByRecruiters);
              const totalAssignees = assignmentToTeams.length + assignmentByRecruiters.length;
              if (totalAssignees > 1) {
                setOpenJobAssignmentSelection(true);
              } else if (totalAssignees == 1) {
                return assignment?.team?.id
                  ? acceptJobAssignment(assignment, assignment.team?.id)
                  : acceptJobAssignment(assignment, assignmentByRecruiters[0]);
              } else {
                const teamIdOrRecruiterId = !isEmpty(assignmentToTeams)
                  ? assignmentToTeams[0]
                  : assignmentByRecruiters[0];
                return acceptJobAssignment(assignment, teamIdOrRecruiterId);
              }
            } else {
              return true;
            }
          } else {
            const jobOwner = job.team ? job.team.name : 'Job Owner';
            setNotification(
              warning(
                `${jobOwner} didn't assign this job to your team.  To add candidates, please get this assigned to your team`
              )
            );
            onClose();
            return false;
          }
        } else {
          const jobOwner = job.team ? job.team.name : 'Job Owner';
          setNotification(
            warning(
              `${jobOwner} didn't assign this job to your team.  To add candidates, please get this assigned to your team`
            )
          );
          onClose();
          return false;
        }
      }
    },
    [acceptJobAssignment, onClose, setNotification]
  );

  useEffect(() => {
    validAssignment(selectedJob);
  }, [selectedJob, validAssignment]);

  const validateCV = (candidate: any) => {
    if (!candidate?.resumeLocation) {
      setNotification(warning('Please Upload Cv for the candidate'));
      return false;
    }
    return true;
  };

  const validateJobSelection = (selectedJob: any) => {
    if (!selectedJob) {
      setNotification(warning('Please select job first'));
      return false;
    }
    return true;
  };

  const validateDuplicateSubmission = async (candidate: any, selectedJob: any) => {
    const duplicateSubmission = await checkExistingSubmission(candidate, selectedJob);
    if (duplicateSubmission) {
      setDisableSubmit(false);
      setIsDuplicate(true);
      onSuccess && onSuccess('Duplicate');
      return true;
    }
    return false;
  };

  const validateCandidateEligibility = (candidate: any, bulkSubmission: boolean) => {
    if (candidate && candidate.isJobCandidateMapping === false && !bulkSubmission) {
      return true;
    }
    return false;
  };

  const update = async (data: FieldValues, conversation: ICandidate) => {
    const response = await updateSubmission(
      data,
      {
        ...conversation,
        editSubmissionDetails: true,
        payRateExpensesType: data.payRateExpensesType ?? 'FIXED',
      },
      otherDocument,
      resume.current,
      selectedJob
    );
    if (response) {
      setNotification(success('Submission Update'));
      !bulkSubmission &&
        navigate(
          `/candidate-layout/submissions?id=${response?.[0]?.candidateId}&array=${[
            response?.[0]?.candidateId,
          ]}`,
          { replace: true, state: {} }
        );
      bulkSubmission && onClose();
      onSuccess && onSuccess('Updated');
    } else {
      setDisableSubmit(false);
      setNotification(failed('Update failed'));
    }
  };

  const checkExistingSubmission = async (candidate: any, job: any) => {
    try {
      const candidateId = candidate?.candidateId ?? candidate?.id ?? '';
      if (!isEmpty(candidateId) && job?.id) {
        const response = await getSubmissionsByCandidateIdAndJobId(
          candidate.candidateId ?? candidate?.id,
          job.id
        );
        return response?.data ? true : false;
      }
      return false;
    } catch (e) {
      return false;
    }
  };

  const handleSubmitClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    setDisableSubmit(true);
    const anchorElement = event.currentTarget;
    const isValid = await methods.trigger();
    if (!isValid) {
      setNotification(warning(onError(methods.formState.errors)));
      setDisableSubmit(false);
      return;
    }

    if (!validateCV(candidate) || !validateJobSelection(selectedJob)) {
      setDisableSubmit(false);
      return;
    }

    if (candidate && validateCandidateEligibility(candidate, bulkSubmission)) {
      updateResumeDetails(candidate);
      update(methods.getValues(), candidate);
      return;
    }

    setAnchorEl(anchorElement);
    setDisableSubmit(false);
  };

  const handlePopoverClose = () => setAnchorEl(null);

  const emailDrawerClose = () => {
    setOpenEmail(false);
    onClose();
  };

  const onFormSubmit = (
    submitType: SubmissionType,
    recruiter: any,
    proceed: boolean,
    comment: string,
    emailBody: string
  ) => {
    const submissionSettings =
      (submissionStageData.find(
        (item) => item.submissionType === submitType
      ) as Partial<ISubmissionStageStatusSetting>) || {};
    const formData = methods.getValues();
    const submissionData = {
      ...formData,
      submitType,
      assignedRecruiter: submitType === SubmissionType.INTERNAL ? recruiter?.email ?? '' : null,
      assignToUserName: submitType === SubmissionType.INTERNAL ? recruiter?.name ?? '' : null,
      applicationStage: submissionSettings?.applicationStage ?? 'CV Submitted',
      applicationState: submissionSettings?.applicationState ?? 'Feedback Pending',
      comment: comment ?? '',
      proceed: proceed || false,
      emailBody: emailBody ?? '',
      workAuthorizationCategory: updateWorkAuthorizationCategory(formData),
    };
    submit(submissionData);
    handlePopoverClose();
  };

  const updateResumeDetails = (candidate: ICandidate) => {
    const selectedCV = CVOptions[Number(getValues('cv'))] ?? {};
    const resumeDetails = {
      resumeFileOriginalName: selectedCV.documentFileName || '',
      resumeLocation: selectedCV.documentLocation || '',
      resumeUploadedOn: selectedCV.documentUploadedOn
        ? new Date(selectedCV.documentUploadedOn)
        : new Date(),
    };

    Object.assign(candidate, resumeDetails);
    resume.current = { ...resumeDetails };

    candidate.mappedCandidateResumes = [
      {
        candidateMappingId: '',
        email: '',
        gitHubLink: '',
        id: '',
        linkedInLink: '',
        phone: '',
        pinCode: '',
        ...resumeDetails,
      },
    ];
  };

  const createSubmissionPayload = (): ICandidate | null => {
    if (!candidate) return null;
    updateResumeDetails(candidate);
    return createSubmissionEntity(
      methods.getValues(),
      candidate,
      selectedJob,
      otherDocument,
      resume.current
    );
  };
  const submit = async (data: FieldValues) => {
    if (!candidate || !data?.proceed) return;

    updateResumeDetails(candidate);

    if (validateCandidateEligibility(candidate, bulkSubmission)) {
      return update(data, candidate);
    }

    if (await validateDuplicateSubmission(candidate, selectedJob)) return;
    addCandidateNote(candidate, data?.comment, loggedInUserName);
    const response = await saveSubmission(
      data,
      candidate,
      selectedJob,
      otherDocument,
      resume.current
    );

    if (!response || typeof response === 'string') {
      setDisableSubmit(false);
      return setNotification(failed(response || 'Submission failed'));
    }
    setCandidate(response);
    setNotification(success('Candidate is submitted to selected job'));
    onSuccess?.('Submitted');
    if (data?.submitType === SubmissionType.EXTERNAL) {
      setSubmissionEmailBody(response?.submissionEmailBody ?? '');
      setOpenEmail(true);
    } else {
      navigateToSubmission(response?.candidateId);
    }
  };

  const navigateToSubmission = (candidateId?: string) => {
    onClose();
    if (!pathName.includes('candidate-layout') && candidateId) {
      navigate(`/candidate-layout/submissions?id=${candidateId}&array=${[candidateId]}`);
    }
  };

  const onUpload = async (file: File[], field: string) => {
    const url = await uploadFileToS3(file[0]);
    const resumeLink = url.split('?')[0];
    if (field === 'document') {
      const alteredCandidate = candidate ?? newMappingEntity();
      const alteredDocuments = [...otherDocument];
      alteredDocuments.push({
        documentLocation: resumeLink,
        originalName: file[0].name,
        tag: null,
        uploadedOn: new Date(),
      });
      setOtherDocument([...alteredDocuments]);
      setAllowReset(false);
      alteredCandidate.otherDocuments = alteredDocuments;
      setCandidate({ ...alteredCandidate });
    }
  };

  const resumeAction = (
    action: string,
    url: string | null = CVOptions[getValues('cv')]?.documentLocation ?? '',
    docName?: string | null
  ) => {
    switch (action) {
      case 'view':
        !isEmpty(url) && trackCV('view', url, cvViewSourcePage);
        setOpenCvView({ open: true, url: url });
        break;
      case 'download':
        if (!isEmpty(url)) {
          trackCV('download', url, cvViewSourcePage);
          url && downloadCV(url, docName ?? CVOptions[getValues('cv')]?.documentFileName ?? '');
        }
        break;
      case 'removeCandidate':
        if (candidate) {
          setIsResumeDeleted(true);
          const alteredCandidate = { ...candidate };
          alteredCandidate.resumeFileOriginalName = '';
          alteredCandidate.resumeLocation = '';
          alteredCandidate.resumeUploadedOn = null;
          setCandidate({ ...alteredCandidate });
        }
        break;
      case 'removeOtherDocument':
        if (candidate) {
          const alteredCandidate = { ...candidate };
          alteredCandidate.otherDocuments = alteredCandidate?.otherDocuments?.filter(
            (document) => document.documentLocation != url
          );
          setCandidate({ ...alteredCandidate });
        }
        break;
    }
  };

  useEffect(() => {
    const updateCandidateResume = async () => {
      const candidateId = candidate?.candidateId ?? candidate?.id ?? '';
      if (candidate && isEmpty(candidate?.resumeFileOriginalName) && !isResumeDeleted) {
        const allCVDetails = await getTopCV(candidateId);
        if (allCVDetails?.data.length > 0) {
          const alteredCandidate = { ...candidate };
          alteredCandidate.resumeFileOriginalName = allCVDetails.data[0]?.documentFileName;
          alteredCandidate.resumeLocation = allCVDetails.data[0]?.documentLocation;
          alteredCandidate.resumeUploadedOn = allCVDetails.data[0]?.documentUploadedOn;
          setCandidate({ ...alteredCandidate });
        }
      }
    };
    updateCandidateResume();
  }, [candidate]);
  const onEditClick = () => setOpenEditCandidate(true);
  const formatCVOptions = useMemo(
    () =>
      (CVOptions || []).map((option, index) => ({
        label: option?.documentFileName || '',
        value: index,
      })),
    [CVOptions]
  );

  const updateCandidate = (data: ICandidate) => {
    setCandidate(data);
    reset(submissionFormDefaultValues(data, selectedJob, buContext));
  };

  return submissionSetting ? (
    <>
      {selectedJob != null && assignmentData !== null && openJobAssignmentSelection ? (
        <>
          <JobAssignmentSelection
            open={openJobAssignmentSelection}
            assignment={assignmentData}
            assignmentToTeams={assignmentToTeams}
            assignmentByRecruiters={assignmentByRecruiters}
            acceptJobAssignment={acceptJobAssignment}
            onClose={() => setOpenJobAssignmentSelection(false)}
          />
        </>
      ) : (
        <>
          <ChatBoxHeader>
            <Grid container p={1}>
              <Grid item xs={3}>
                <Box mt={0}>
                  <WsTypography
                    variant={WsTypoVariants.TITLE}
                    color={WsTypoColors.PRIMARY}
                    bold={true}
                  >
                    Submit
                  </WsTypography>
                </Box>
              </Grid>
              <Grid item xs={9}>
                <Box sx={{ float: 'right', mr: 2 }}>
                  <Stack direction="row" spacing={3}>
                    {!hideJobSelection ? (
                      <WidgetJobManagement
                        selectedJob={selectedJob}
                        ss={12}
                        isFromMapAsLead={true}
                        setRemoveForMap={setRemove}
                      />
                    ) : (
                      <WsTypography variant={WsTypoVariants.BODY1} bold={true}>
                        {`${selectedJob?.title} ( ${selectedJob?.jobCode} )`}
                      </WsTypography>
                    )}

                    <CloseIcon sx={{ cursor: 'pointer' }} onClick={onClose} />
                  </Stack>
                </Box>
              </Grid>
            </Grid>
          </ChatBoxHeader>
          {!isDuplicate ? (
            <FormProvider {...methods}>
              <form onKeyDown={(e) => e.code === 'Enter' && e.preventDefault()}>
                <Box
                  sx={{
                    px: 1.5,
                    pb: 1.5,
                    background: WsColors.TertiaryShades100,
                    maxHeight: '80vh',
                    overflowY: 'auto',
                  }}
                >
                  <Paper>
                    <Grid
                      item
                      xs={12}
                      px={2.5}
                      py={1.25}
                      sx={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 1,
                        background: WsColors.White,
                      }}
                    >
                      <LinearProgressWithLabel
                        value={linearProgressValue}
                        sx={{ height: 10, borderRadius: 2 }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <PersonalInfo
                        showTitle={false}
                        candidate={candidate ?? ({} as ICandidate)}
                        onUpload={(file: File[]) => onUpload(file, 'resume')}
                        submissionSetting={submissionSetting}
                        resumeAction={resumeAction}
                        onEditClick={onEditClick}
                        CVOptions={formatCVOptions}
                      />
                      <LocationInfo submissionSetting={submissionSetting} showTitle={false} />
                      <WorkExpForm submissionSetting={submissionSetting} showTitle={false} />
                      <JobPreference
                        watch={watch}
                        submissionSetting={submissionSetting}
                        showTitle={false}
                      />
                      <SalaryDetails
                        job={selectedJob ?? undefined}
                        submissionSetting={submissionSetting}
                        showTitle={false}
                      />
                      <AssessmentInfo submissionSetting={submissionSetting} showTitle={false} />
                      <DocumentInfo
                        candidate={candidate}
                        submissionSetting={submissionSetting}
                        onUpload={(file: File[]) => onUpload(file, 'document')}
                        resumeAction={resumeAction}
                      />
                      <Grid pb={2}>
                        <BusinessUnit
                          submissionSetting={submissionSetting}
                          name="buId"
                          defaultValue={getBuId(candidate, buContext)}
                        />
                      </Grid>
                      <SubmissionFormNewFields submissionSetting={submissionSetting} />
                      <Grid>
                        <CardWithAccordion
                          title="Other details"
                          topChild={<></>}
                          bottomChild={<OtherSubmissionDetails details={otherDetails} />}
                          onEditClick={onEditClick}
                          hasData={!isEmpty(otherDetails)}
                        />
                      </Grid>
                    </Grid>
                  </Paper>
                </Box>
                <ActionFooter>
                  {submissionFormDefaultValues(candidate).rtrConsent && (
                    <Grid item container>
                      <StyledCheckBox
                        name="rtrConsent"
                        checked={
                          candidate
                            ? submissionFormDefaultValues(candidate).rtrConsent ?? false
                            : getValues('rtrConsent')
                        }
                        onChange={(ev) => setValue('rtrConsent', ev.target.checked)}
                      />
                      <Typography noWrap>
                        I have spoken to the Candidate for their interest in this Position and have
                        obtained the Right to Represent.
                      </Typography>
                    </Grid>
                  )}

                  <Grid item container xs={6} justifyContent="flex-end">
                    <Box mr={3}>
                      <WsButton type="button" onClick={handleSubmitClick} disabled={disableSubmit}>
                        Submit
                      </WsButton>
                    </Box>
                  </Grid>
                  <SubmitOptions
                    anchorEl={anchorEl}
                    onClose={handlePopoverClose}
                    onInternalSubmit={(rec, comment, emailBody) =>
                      onFormSubmit(SubmissionType.INTERNAL, rec, true, comment, emailBody)
                    }
                    onExternalSubmit={(proc, emailBody) =>
                      onFormSubmit(SubmissionType.EXTERNAL, null, proc, '', emailBody)
                    }
                    getSubmissionPayload={createSubmissionPayload}
                    job={selectedJob}
                  />
                </ActionFooter>
              </form>
            </FormProvider>
          ) : (
            <Stack
              direction="column"
              spacing={2}
              mt={4}
              justifyContent="center"
              alignItems="center"
            >
              <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.ERROR}>
                Duplicate Candidate
              </WsTypography>
              <WsTypography>{`This Candidate is already submitted for the job ${selectedJob?.title} (${selectedJob?.jobCode})`}</WsTypography>
            </Stack>
          )}
        </>
      )}
      {openEditCandidate && (
        <>
          <WsDrawer
            open={openEditCandidate}
            title="Edit Profile"
            style={{ zIndex: '1300' }}
            onClose={() => setOpenEditCandidate(false)}
            size="large"
          >
            <CandidateProfileDetailsEdit
              close={() => setOpenEditCandidate(false)}
              candidate={candidate ?? ({} as ICandidate)}
              updateCandidate={updateCandidate}
            />
          </WsDrawer>
        </>
      )}
      {openCvView.open && (
        <CVViewModal
          open={openCvView.open}
          s3url={openCvView.url}
          handleClose={() => setOpenCvView({ open: false, url: openCvView.url })}
        />
      )}
      {openEmail && candidate && selectedJob && submissionEmailBody && (
        <EmailPopUp
          candidate={candidate}
          job={selectedJob}
          openEmail={openEmail}
          onClose={emailDrawerClose}
          mailBody={submissionEmailBody}
        />
      )}
      {openMergeCandidate && existingCandidate && candidate && (
        <AddContactLink
          open={openMergeCandidate}
          onClose={() => setOpenMergeCandidate(false)}
          isEmail={false}
          isPhone={false}
          isMerge={true}
          existingCandidate={existingCandidate}
          newEmail={newSocialLink ?? ''}
          candidate={candidate}
        />
      )}
    </>
  ) : (
    <WsListingLoader />
  );
};

export default MapAsSubmission;
